'use client';

import { motion, useReducedMotion } from 'motion/react';
import { Link } from '@/i18n/navigation';
import { ArrowRight, ShoppingBag } from 'lucide-react';
import { localized, type HomeContentConfig, type RestaurantLocale } from '@restaurant/config';
import styles from './CTASection.module.css';

const EASE = [0.22, 1, 0.36, 1] as const;

interface CTASectionProps {
  content: HomeContentConfig['footerCtas'];
  locale: RestaurantLocale;
}

export function CTASection({ content, locale }: CTASectionProps) {
  const reduced = useReducedMotion();

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {content.showMenu && <motion.div
          initial={reduced ? false : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.65, delay: 0, ease: EASE }}
          style={{ display: 'contents' }}
        >
          <Link href={content.menuHref as any} className={styles.ctaCard}>
            <span>
              <span className={styles.eyebrow}>{localized(content.menuEyebrow, locale)}</span>
              <span className={styles.title}>{localized(content.menuTitle, locale)}</span>
            </span>
            <ArrowRight aria-hidden="true" />
          </Link>
        </motion.div>}
        {content.showTakeaway && <motion.div
          initial={reduced ? false : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.65, delay: 0.14, ease: EASE }}
          style={{ display: 'contents' }}
        >
          <Link href={content.takeawayHref as any} className={styles.ctaCard}>
            <span>
              <span className={styles.eyebrow}>{localized(content.takeawayEyebrow, locale)}</span>
              <span className={styles.title}>{localized(content.takeawayTitle, locale)}</span>
            </span>
            <ShoppingBag aria-hidden="true" />
          </Link>
        </motion.div>}
      </div>
    </section>
  );
}
